import './polyfills';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import 'lazysizes';
import Routes from './routes';
import { createGlobalStyle } from 'styled-components';
import { Format } from './utils/styles-constants';
import AppTypeUtils from './utils/appType';
import UserAgentUtils from './utils/userAgent';

export const GlobalStyle = createGlobalStyle`
	body {
		overflow: hidden;
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		top: 0;
		margin: 0;
		padding: 0;
		font-family: 'HelveticaNeue', sans-serif;
		font-weight: 400;
		font-size: 14px;
		-webkit-tap-highlight-color: rgba(0,0,0,0);

		&.no-user-select {
			user-select: none;
		}

		@media ${Format.SmartphonePortrait} {
			text-size-adjust: none;
		}

		@media print {
			@page {
				size: A4;
				margin:0;
			}
			&,
			#root > div {
				overflow: visible;
				position: static;
				margin: 0;
				width: 210mm;
				height: 297mm;
			}
			.StyledHeader {
				display: none;
			}
		}
	}

	.__react_component_tooltip {
		margin: 0!important;
		padding: 0!important;
		background: none!important;
	}

	.__react_component_tooltip:before,
	.__react_component_tooltip:after {
		content: none!important;
	}

	@font-face {
		font-family: 'HelveticaNeue';
		font-style: normal;
		font-weight: 300;
		src: url('./.gallery/static/media/HelveticaNeueUltraLight.ttf') format('truetype');
	}

	@font-face {
		font-family: 'HelveticaNeue';
		font-style: normal;
		font-weight: 400;
		src: url('./.gallery/static/media/HelveticaNeueLight.ttf') format('truetype');
	}

	@font-face {
		font-family: 'HelveticaNeue';
		font-style: normal;
		font-weight: 500;
		src: url('./.gallery/static/media/HelveticaNeueRoman.ttf') format('truetype');
	}

	@font-face {
		font-family: 'HelveticaNeue';
		font-style: normal;
		font-weight: 600;
		src: url('./.gallery/static/media/HelveticaNeueMedium.ttf') format('truetype');
	}

	@font-face {
		font-family: 'HelveticaNeue';
		font-style: normal;
		font-weight: 700;
		src: url('./.gallery/static/media/HelveticaNeueBold.ttf') format('truetype');
	}

	svg { // on edge, can't click on the button behind the button icon without this line
		pointer-events: none;
	}
`;

const init = async () => {
	// AppTypeUtils must be initialized because a lot of methods/Utils require to know if we are in a mobile app
	await AppTypeUtils.init();
	UserAgentUtils.initApp();

	ReactDOM.render(
		<>
			<Routes />
			<GlobalStyle />
		</>,
		document.getElementById('root')
	);
};

init();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx